function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e10) {
          throw _e10;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e11) {
      didErr = true;
      err = _e11;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import t from "delegate-it";
import { match as e } from "path-to-regexp";
var n = function n(t, e) {
    return String(t).toLowerCase().replace(/[\s/_.]+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+|-+$/g, "") || e || "";
  },
  o = function o() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      t = _ref.hash;
    return window.location.pathname + window.location.search + (t ? window.location.hash : "");
  },
  r = function r(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var n = _objectSpread({
      url: t = t || o({
        hash: !0
      }),
      random: Math.random(),
      source: "swup"
    }, e);
    window.history.pushState(n, "", t);
  },
  i = function i() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    t = t || o({
      hash: !0
    });
    var n = _objectSpread(_objectSpread({}, window.history.state || {}), {}, {
      url: t,
      random: Math.random(),
      source: "swup"
    }, e);
    window.history.replaceState(n, "", t);
  },
  s = function s(e, n, o, r) {
    var i = new AbortController();
    return r = _objectSpread(_objectSpread({}, r), {}, {
      signal: i.signal
    }), t(e, n, o, r), {
      destroy: function destroy() {
        return i.abort();
      }
    };
  };
var a = /*#__PURE__*/function (_URL) {
  _inherits(a, _URL);
  var _super = _createSuper(a);
  function a(t) {
    var _this;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.baseURI;
    _classCallCheck(this, a);
    _this = _super.call(this, t.toString(), e), Object.setPrototypeOf(_assertThisInitialized(_this), a.prototype);
    return _this;
  }
  _createClass(a, [{
    key: "url",
    get: function get() {
      return this.pathname + this.search;
    }
  }], [{
    key: "fromElement",
    value: function fromElement(t) {
      var e = t.getAttribute("href") || t.getAttribute("xlink:href") || "";
      return new a(e);
    }
  }, {
    key: "fromUrl",
    value: function fromUrl(t) {
      return new a(t);
    }
  }]);
  return a;
}( /*#__PURE__*/_wrapNativeSuper(URL));
var c = function c(t, n) {
    try {
      return e(t, n);
    } catch (e) {
      throw new Error("[swup] Error parsing path \"".concat(String(t), "\":\n").concat(String(e)));
    }
  },
  l = function l(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    try {
      var _e$timeout;
      var _n = function _n(n) {
        var _u2 = _u,
          i = _u2.status,
          s = _u2.url;
        return Promise.resolve(_u.text()).then(function (n) {
          if (500 === i) throw _o.hooks.call("fetch:error", _r, {
            status: i,
            response: _u,
            url: s
          }), new h("Server error: ".concat(s), {
            status: i,
            url: s
          });
          if (!n) throw new h("Empty response: ".concat(s), {
            status: i,
            url: s
          });
          var _a$fromUrl = a.fromUrl(s),
            c = _a$fromUrl.url,
            l = {
              url: c,
              html: n
            };
          return !_r.cache.write || e.method && "GET" !== e.method || t !== c || _o.cache.set(l.url, l), l;
        });
      };
      var _o = this;
      t = a.fromUrl(t).url;
      var _e = e,
        _e$visit = _e.visit,
        _r = _e$visit === void 0 ? _o.visit : _e$visit,
        _i = _objectSpread(_objectSpread({}, _o.options.requestHeaders), e.headers),
        _s = (_e$timeout = e.timeout) !== null && _e$timeout !== void 0 ? _e$timeout : _o.options.timeout,
        _c = new AbortController(),
        _l = _c.signal;
      e = _objectSpread(_objectSpread({}, e), {}, {
        headers: _i,
        signal: _l
      });
      var _u,
        _d = !1,
        _m = null;
      _s && _s > 0 && (_m = setTimeout(function () {
        _d = !0, _c.abort("timeout");
      }, _s));
      var _f = function (n, i) {
        try {
          var s = Promise.resolve(_o.hooks.call("fetch:request", _r, {
            url: t,
            options: e
          }, function (t, _ref2) {
            var e = _ref2.url,
              n = _ref2.options;
            return fetch(e, n);
          })).then(function (t) {
            _u = t, _m && clearTimeout(_m);
          });
        } catch (t) {
          return i(t);
        }
        return s && s.then ? s.then(void 0, i) : s;
      }(0, function (e) {
        if (_d) throw _o.hooks.call("fetch:timeout", _r, {
          url: t
        }), new h("Request timed out: ".concat(t), {
          url: t,
          timedOut: _d
        });
        if ("AbortError" === (e === null || e === void 0 ? void 0 : e.name) || _l.aborted) throw new h("Request aborted: ".concat(t), {
          url: t,
          aborted: !0
        });
        throw e;
      });
      return Promise.resolve(_f && _f.then ? _f.then(_n) : _n());
    } catch (p) {
      return Promise.reject(p);
    }
  };
var h = /*#__PURE__*/function (_Error) {
  _inherits(h, _Error);
  var _super2 = _createSuper(h);
  function h(t, e) {
    var _this2;
    _classCallCheck(this, h);
    _this2 = _super2.call(this, t), _this2.url = void 0, _this2.status = void 0, _this2.aborted = void 0, _this2.timedOut = void 0, _this2.name = "FetchError", _this2.url = e.url, _this2.status = e.status, _this2.aborted = e.aborted || !1, _this2.timedOut = e.timedOut || !1;
    return _this2;
  }
  return h;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var u = /*#__PURE__*/function () {
  function u(t) {
    _classCallCheck(this, u);
    this.swup = void 0, this.pages = new Map(), this.swup = t;
  }
  _createClass(u, [{
    key: "size",
    get: function get() {
      return this.pages.size;
    }
  }, {
    key: "all",
    get: function get() {
      var t = new Map();
      return this.pages.forEach(function (e, n) {
        t.set(n, _objectSpread({}, e));
      }), t;
    }
  }, {
    key: "has",
    value: function has(t) {
      return this.pages.has(this.resolve(t));
    }
  }, {
    key: "get",
    value: function get(t) {
      var e = this.pages.get(this.resolve(t));
      return e ? _objectSpread({}, e) : e;
    }
  }, {
    key: "set",
    value: function set(t, e) {
      t = this.resolve(t), e = _objectSpread(_objectSpread({}, e), {}, {
        url: t
      }), this.pages.set(t, e), this.swup.hooks.callSync("cache:set", void 0, {
        page: e
      });
    }
  }, {
    key: "update",
    value: function update(t, e) {
      t = this.resolve(t);
      var n = _objectSpread(_objectSpread(_objectSpread({}, this.get(t)), e), {}, {
        url: t
      });
      this.pages.set(t, n);
    }
  }, {
    key: "delete",
    value: function _delete(t) {
      this.pages["delete"](this.resolve(t));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.pages.clear(), this.swup.hooks.callSync("cache:clear", void 0, void 0);
    }
  }, {
    key: "prune",
    value: function prune(t) {
      var _this3 = this;
      this.pages.forEach(function (e, n) {
        t(n, e) && _this3["delete"](n);
      });
    }
  }, {
    key: "resolve",
    value: function resolve(t) {
      var _a$fromUrl2 = a.fromUrl(t),
        e = _a$fromUrl2.url;
      return this.swup.resolveUrl(e);
    }
  }]);
  return u;
}();
var d = function d(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    return e.querySelector(t);
  },
  m = function m(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    return Array.from(e.querySelectorAll(t));
  },
  f = function f() {
    return new Promise(function (t) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          t();
        });
      });
    });
  };
function p(t) {
  return !!t && ("object" == _typeof(t) || "function" == typeof t) && "function" == typeof t.then;
}
function v(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return new Promise(function (n, o) {
    var r = t.apply(void 0, _toConsumableArray(e));
    p(r) ? r.then(n, o) : n(r);
  });
}
function g(t) {
  var _t;
  t = t || document.body, (_t = t) === null || _t === void 0 ? void 0 : _t.getBoundingClientRect();
}
function w(t, e) {
  var n = t === null || t === void 0 ? void 0 : t.closest("[".concat(e, "]"));
  return n !== null && n !== void 0 && n.hasAttribute(e) ? (n === null || n === void 0 ? void 0 : n.getAttribute(e)) || !0 : void 0;
}
var y = /*#__PURE__*/function () {
  function y(t) {
    _classCallCheck(this, y);
    this.swup = void 0, this.swupClasses = ["to-", "is-changing", "is-rendering", "is-popstate", "is-animating", "is-leaving"], this.swup = t;
  }
  _createClass(y, [{
    key: "selectors",
    get: function get() {
      var t = this.swup.visit.animation.scope;
      return "containers" === t ? this.swup.visit.containers : "html" === t ? ["html"] : Array.isArray(t) ? t : [];
    }
  }, {
    key: "selector",
    get: function get() {
      return this.selectors.join(",");
    }
  }, {
    key: "targets",
    get: function get() {
      return this.selector.trim() ? m(this.selector) : [];
    }
  }, {
    key: "add",
    value: function add() {
      var _arguments = arguments;
      this.targets.forEach(function (t) {
        var _t$classList;
        return (_t$classList = t.classList).add.apply(_t$classList, _toConsumableArray([].slice.call(_arguments)));
      });
    }
  }, {
    key: "remove",
    value: function remove() {
      var _arguments2 = arguments;
      this.targets.forEach(function (t) {
        var _t$classList2;
        return (_t$classList2 = t.classList).remove.apply(_t$classList2, _toConsumableArray([].slice.call(_arguments2)));
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this4 = this;
      this.targets.forEach(function (t) {
        var _t$classList3;
        var e = t.className.split(" ").filter(function (t) {
          return _this4.isSwupClass(t);
        });
        (_t$classList3 = t.classList).remove.apply(_t$classList3, _toConsumableArray(e));
      });
    }
  }, {
    key: "isSwupClass",
    value: function isSwupClass(t) {
      return this.swupClasses.some(function (e) {
        return t.startsWith(e);
      });
    }
  }]);
  return y;
}();
var k = /*#__PURE__*/function () {
  function k(t, e) {
    _classCallCheck(this, k);
    this.id = void 0, this.state = void 0, this.from = void 0, this.to = void 0, this.containers = void 0, this.animation = void 0, this.trigger = void 0, this.cache = void 0, this.history = void 0, this.scroll = void 0;
    var n = e.to,
      o = e.from,
      r = e.hash,
      i = e.el,
      s = e.event;
    this.id = Math.random(), this.state = 1, this.from = {
      url: o !== null && o !== void 0 ? o : t.location.url,
      hash: t.location.hash
    }, this.to = {
      url: n,
      hash: r
    }, this.containers = t.options.containers, this.animation = {
      animate: !0,
      wait: !1,
      name: void 0,
      "native": t.options["native"],
      scope: t.options.animationScope,
      selector: t.options.animationSelector
    }, this.trigger = {
      el: i,
      event: s
    }, this.cache = {
      read: t.options.cache,
      write: t.options.cache
    }, this.history = {
      action: "push",
      popstate: !1,
      direction: void 0
    }, this.scroll = {
      reset: !0,
      target: void 0
    };
  }
  _createClass(k, [{
    key: "advance",
    value: function advance(t) {
      this.state < t && (this.state = t);
    }
  }, {
    key: "abort",
    value: function abort() {
      this.state = 8;
    }
  }, {
    key: "done",
    get: function get() {
      return this.state >= 7;
    }
  }]);
  return k;
}();
function P(t) {
  return new k(this, t);
}
var b = "undefined" != typeof Symbol ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
function S(t, e, n) {
  if (!t.s) {
    if (n instanceof E) {
      if (!n.s) return void (n.o = S.bind(null, t, e));
      1 & e && (e = n.s), n = n.v;
    }
    if (n && n.then) return void n.then(S.bind(null, t, e), S.bind(null, t, 2));
    t.s = e, t.v = n;
    var _o2 = t.o;
    _o2 && _o2(t);
  }
}
var E = /*#__PURE__*/function () {
  function t() {}
  return t.prototype.then = function (e, n) {
    var o = new t(),
      r = this.s;
    if (r) {
      var _t2 = 1 & r ? e : n;
      if (_t2) {
        try {
          S(o, 1, _t2(this.v));
        } catch (t) {
          S(o, 2, t);
        }
        return o;
      }
      return this;
    }
    return this.o = function (t) {
      try {
        var _r2 = t.v;
        1 & t.s ? S(o, 1, e ? e(_r2) : _r2) : n ? S(o, 1, n(_r2)) : S(o, 2, _r2);
      } catch (t) {
        S(o, 2, t);
      }
    }, o;
  }, t;
}();
function C(t) {
  return t instanceof E && 1 & t.s;
}
var U = /*#__PURE__*/function () {
  function U(t) {
    _classCallCheck(this, U);
    this.swup = void 0, this.registry = new Map(), this.hooks = ["animation:out:start", "animation:out:await", "animation:out:end", "animation:in:start", "animation:in:await", "animation:in:end", "animation:skip", "cache:clear", "cache:set", "content:replace", "content:scroll", "enable", "disable", "fetch:request", "fetch:error", "fetch:timeout", "history:popstate", "link:click", "link:self", "link:anchor", "link:newtab", "page:load", "page:view", "scroll:top", "scroll:anchor", "visit:start", "visit:transition", "visit:abort", "visit:end"], this.swup = t, this.init();
  }
  _createClass(U, [{
    key: "init",
    value: function init() {
      var _this5 = this;
      this.hooks.forEach(function (t) {
        return _this5.create(t);
      });
    }
  }, {
    key: "create",
    value: function create(t) {
      this.registry.has(t) || this.registry.set(t, new Map());
    }
  }, {
    key: "exists",
    value: function exists(t) {
      return this.registry.has(t);
    }
  }, {
    key: "get",
    value: function get(t) {
      var e = this.registry.get(t);
      if (e) return e;
      console.error("Unknown hook '".concat(t, "'"));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.registry.forEach(function (t) {
        return t.clear();
      });
    }
  }, {
    key: "on",
    value: function on(t, e) {
      var _this6 = this;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = this.get(t);
      if (!o) return console.warn("Hook '".concat(t, "' not found.")), function () {};
      var r = _objectSpread(_objectSpread({}, n), {}, {
        id: o.size + 1,
        hook: t,
        handler: e
      });
      return o.set(e, r), function () {
        return _this6.off(t, e);
      };
    }
  }, {
    key: "before",
    value: function before(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.on(t, e, _objectSpread(_objectSpread({}, n), {}, {
        before: !0
      }));
    }
  }, {
    key: "replace",
    value: function replace(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.on(t, e, _objectSpread(_objectSpread({}, n), {}, {
        replace: !0
      }));
    }
  }, {
    key: "once",
    value: function once(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.on(t, e, _objectSpread(_objectSpread({}, n), {}, {
        once: !0
      }));
    }
  }, {
    key: "off",
    value: function off(t, e) {
      var n = this.get(t);
      n && e ? n["delete"](e) || console.warn("Handler for hook '".concat(t, "' not found.")) : n && n.clear();
    }
  }, {
    key: "call",
    value: function call(t, e, n, o) {
      try {
        var _r3 = this,
          _r3$parseCallArgs = _r3.parseCallArgs(t, e, n, o),
          _r3$parseCallArgs2 = _slicedToArray(_r3$parseCallArgs, 3),
          _i2 = _r3$parseCallArgs2[0],
          _s2 = _r3$parseCallArgs2[1],
          _a = _r3$parseCallArgs2[2],
          _r3$getHandlers = _r3.getHandlers(t, _a),
          _c2 = _r3$getHandlers.before,
          _l2 = _r3$getHandlers.handler,
          _h = _r3$getHandlers.after;
        return Promise.resolve(_r3.run(_c2, _i2, _s2)).then(function () {
          return Promise.resolve(_r3.run(_l2, _i2, _s2, !0)).then(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 1),
              e = _ref4[0];
            return Promise.resolve(_r3.run(_h, _i2, _s2)).then(function () {
              return _r3.dispatchDomEvent(t, _i2, _s2), e;
            });
          });
        });
      } catch (t) {
        return Promise.reject(t);
      }
    }
  }, {
    key: "callSync",
    value: function callSync(t, e, n, o) {
      var _this$parseCallArgs = this.parseCallArgs(t, e, n, o),
        _this$parseCallArgs2 = _slicedToArray(_this$parseCallArgs, 3),
        r = _this$parseCallArgs2[0],
        i = _this$parseCallArgs2[1],
        s = _this$parseCallArgs2[2],
        _this$getHandlers = this.getHandlers(t, s),
        a = _this$getHandlers.before,
        c = _this$getHandlers.handler,
        l = _this$getHandlers.after;
      this.runSync(a, r, i);
      var _this$runSync = this.runSync(c, r, i, !0),
        _this$runSync2 = _slicedToArray(_this$runSync, 1),
        h = _this$runSync2[0];
      return this.runSync(l, r, i), this.dispatchDomEvent(t, r, i), h;
    }
  }, {
    key: "parseCallArgs",
    value: function parseCallArgs(t, e, n, o) {
      return e instanceof k || "object" != _typeof(e) && "function" != typeof n ? [e, n, o] : [void 0, e, n];
    }
  }, {
    key: "run",
    value: function run(t, e, n) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      try {
        var _r4;
        var _i3 = this;
        void 0 === e && (e = _i3.swup.visit);
        var _s3 = [],
          _a2 = function (t, e, n) {
            if ("function" == typeof t[b]) {
              var o,
                r,
                i,
                s = t[b]();
              if (function t(a) {
                try {
                  for (; !((o = s.next()).done || n && n());) {
                    if ((a = e(o.value)) && a.then) {
                      if (!C(a)) return void a.then(t, i || (i = S.bind(null, r = new E(), 2)));
                      a = a.v;
                    }
                  }
                  r ? S(r, 1, a) : r = a;
                } catch (t) {
                  S(r || (r = new E()), 2, t);
                }
              }(), s["return"]) {
                var a = function a(t) {
                  try {
                    o.done || s["return"]();
                  } catch (t) {}
                  return t;
                };
                if (r && r.then) return r.then(a, function (t) {
                  throw a(t);
                });
                a();
              }
              return r;
            }
            if (!("length" in t)) throw new TypeError("Object is not iterable");
            for (var c = [], l = 0; l < t.length; l++) {
              c.push(t[l]);
            }
            return function (t, e, n) {
              var o,
                r,
                i = -1;
              return function s(a) {
                try {
                  for (; ++i < t.length && (!n || !n());) {
                    if ((a = e(i)) && a.then) {
                      if (!C(a)) return void a.then(s, r || (r = S.bind(null, o = new E(), 2)));
                      a = a.v;
                    }
                  }
                  o ? S(o, 1, a) : o = a;
                } catch (t) {
                  S(o || (o = new E()), 2, t);
                }
              }(), o;
            }(c, function (t) {
              return e(c[t]);
            }, n);
          }(t, function (_ref5) {
            var _e2;
            var t = _ref5.hook,
              r = _ref5.handler,
              a = _ref5.defaultHandler,
              c = _ref5.once;
            if (!((_e2 = e) !== null && _e2 !== void 0 && _e2.done)) return c && _i3.off(t, r), function (t, o) {
              try {
                var i = Promise.resolve(v(r, [e, n, a])).then(function (t) {
                  _s3.push(t);
                });
              } catch (t) {
                return o(t);
              }
              return i && i.then ? i.then(void 0, o) : i;
            }(0, function (e) {
              if (o) throw e;
              console.error("Error in hook '".concat(t, "':"), e);
            });
          }, function () {
            return _r4;
          });
        return Promise.resolve(_a2 && _a2.then ? _a2.then(function (t) {
          return _r4 ? t : _s3;
        }) : _r4 ? _a2 : _s3);
      } catch (t) {
        return Promise.reject(t);
      }
    }
  }, {
    key: "runSync",
    value: function runSync(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.swup.visit;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var r = [];
      var _iterator = _createForOfIteratorHelper(t),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _step.value,
            _i4 = _step$value.hook,
            _s4 = _step$value.handler,
            _a3 = _step$value.defaultHandler,
            _c3 = _step$value.once;
          if (!(e !== null && e !== void 0 && e.done)) {
            _c3 && this.off(_i4, _s4);
            try {
              var _t3 = _s4(e, n, _a3);
              r.push(_t3), p(_t3) && console.warn("Swup will not await Promises in handler for synchronous hook '".concat(_i4, "'."));
            } catch (t) {
              if (o) throw t;
              console.error("Error in hook '".concat(_i4, "':"), t);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return r;
    }
  }, {
    key: "getHandlers",
    value: function getHandlers(t, e) {
      var n = this.get(t);
      if (!n) return {
        found: !1,
        before: [],
        handler: [],
        after: [],
        replaced: !1
      };
      var o = Array.from(n.values()),
        r = this.sortRegistrations,
        i = o.filter(function (_ref6) {
          var t = _ref6.before,
            e = _ref6.replace;
          return t && !e;
        }).sort(r),
        s = o.filter(function (_ref7) {
          var t = _ref7.replace;
          return t;
        }).filter(function (t) {
          return !0;
        }).sort(r),
        a = o.filter(function (_ref8) {
          var t = _ref8.before,
            e = _ref8.replace;
          return !t && !e;
        }).sort(r),
        c = s.length > 0;
      var l = [];
      if (e && (l = [{
        id: 0,
        hook: t,
        handler: e
      }], c)) {
        var _n2 = s.length - 1,
          _o3 = function _o3(t) {
            var n = s[t - 1];
            return n ? function (e, r) {
              return n.handler(e, r, _o3(t - 1));
            } : e;
          };
        l = [{
          id: 0,
          hook: t,
          handler: s[_n2].handler,
          defaultHandler: _o3(_n2)
        }];
      }
      return {
        found: !0,
        before: i,
        handler: l,
        after: a,
        replaced: c
      };
    }
  }, {
    key: "sortRegistrations",
    value: function sortRegistrations(t, e) {
      var _t$priority, _e$priority;
      return ((_t$priority = t.priority) !== null && _t$priority !== void 0 ? _t$priority : 0) - ((_e$priority = e.priority) !== null && _e$priority !== void 0 ? _e$priority : 0) || t.id - e.id || 0;
    }
  }, {
    key: "dispatchDomEvent",
    value: function dispatchDomEvent(t, e, n) {
      if (e !== null && e !== void 0 && e.done) return;
      var o = {
        hook: t,
        args: n,
        visit: e || this.swup.visit
      };
      document.dispatchEvent(new CustomEvent("swup:any", {
        detail: o,
        bubbles: !0
      })), document.dispatchEvent(new CustomEvent("swup:".concat(t), {
        detail: o,
        bubbles: !0
      }));
    }
  }]);
  return U;
}();
var $ = function $(t) {
    if (t && "#" === t.charAt(0) && (t = t.substring(1)), !t) return null;
    var e = decodeURIComponent(t);
    var n = document.getElementById(t) || document.getElementById(e) || d("a[name='".concat(CSS.escape(t), "']")) || d("a[name='".concat(CSS.escape(e), "']"));
    return n || "top" !== t || (n = document.body), n;
  },
  x = function x(_ref9) {
    var t = _ref9.selector,
      e = _ref9.elements;
    try {
      if (!1 === t && !e) return Promise.resolve();
      var _n3 = [];
      if (e) _n3 = Array.from(e);else if (t && (_n3 = m(t, document.body), !_n3.length)) return console.warn("[swup] No elements found matching animationSelector `".concat(t, "`")), Promise.resolve();
      var _o4 = _n3.map(function (t) {
        return function (t) {
          var _ref10 = function (t) {
              var e = window.getComputedStyle(t),
                n = j(e, "".concat(A, "Delay")),
                o = j(e, "".concat(A, "Duration")),
                r = V(n, o),
                i = j(e, "".concat(H, "Delay")),
                s = j(e, "".concat(H, "Duration")),
                a = V(i, s),
                c = Math.max(r, a),
                l = c > 0 ? r > a ? A : H : null;
              return {
                type: l,
                timeout: c,
                propCount: l ? l === A ? o.length : s.length : 0
              };
            }(t),
            e = _ref10.type,
            n = _ref10.timeout,
            o = _ref10.propCount;
          return !(!e || !n) && new Promise(function (r) {
            var i = "".concat(e, "end"),
              s = performance.now();
            var a = 0;
            var c = function c() {
                t.removeEventListener(i, l), r();
              },
              l = function l(e) {
                e.target === t && ((performance.now() - s) / 1e3 < e.elapsedTime || ++a >= o && c());
              };
            setTimeout(function () {
              a < o && c();
            }, n + 1), t.addEventListener(i, l);
          });
        }(t);
      });
      return _o4.filter(Boolean).length > 0 ? Promise.resolve(Promise.all(_o4)).then(function () {}) : (t && console.warn("[swup] No CSS animation duration defined on elements matching `".concat(t, "`")), Promise.resolve());
    } catch (t) {
      return Promise.reject(t);
    }
  },
  A = "transition",
  H = "animation";
function j(t, e) {
  return (t[e] || "").split(", ");
}
function V(t, e) {
  for (; t.length < e.length;) {
    t = t.concat(t);
  }
  return Math.max.apply(Math, _toConsumableArray(e.map(function (e, n) {
    return I(e) + I(t[n]);
  })));
}
function I(t) {
  return 1e3 * parseFloat(t);
}
var L = function L(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    var _o5 = function _o5(o) {
      var _e$cache$read, _e$cache$write;
      if (_s5) return o;
      _c4.navigating = !0, _c4.visit = t;
      var l = t.trigger.el;
      e.referrer = e.referrer || _c4.location.url, !1 === e.animate && (t.animation.animate = !1), t.animation.animate || _c4.classes.clear();
      var h = e.history || w(l, "data-swup-history");
      "string" == typeof h && ["push", "replace"].includes(h) && (t.history.action = h);
      var u = e.animation || w(l, "data-swup-animation");
      return "string" == typeof u && (t.animation.name = u), "object" == _typeof(e.cache) ? (t.cache.read = (_e$cache$read = e.cache.read) !== null && _e$cache$read !== void 0 ? _e$cache$read : t.cache.read, t.cache.write = (_e$cache$write = e.cache.write) !== null && _e$cache$write !== void 0 ? _e$cache$write : t.cache.write) : void 0 !== e.cache && (t.cache = {
        read: !!e.cache,
        write: !!e.cache
      }), delete e.cache, function (o, s) {
        try {
          var l = function (o, s) {
            try {
              var l = Promise.resolve(_c4.hooks.call("visit:start", t, void 0)).then(function () {
                function o() {
                  if (!t.done) return Promise.resolve(_c4.hooks.call("visit:transition", t, void 0, function () {
                    try {
                      var _e3 = function _e3(e) {
                        return _n4 ? e : (t.advance(4), Promise.resolve(_c4.animatePageOut(t)).then(function () {
                          function e() {
                            return Promise.resolve(_c4.animatePageIn(t)).then(function () {});
                          }
                          var n = function () {
                            if (t.animation["native"] && document.startViewTransition) return Promise.resolve(document.startViewTransition(function () {
                              try {
                                var _e4 = _c4.renderPage;
                                return Promise.resolve(s).then(function (n) {
                                  return Promise.resolve(_e4.call(_c4, t, n));
                                });
                              } catch (t) {
                                return Promise.reject(t);
                              }
                            }).finished).then(function () {});
                            {
                              var _e5 = _c4.renderPage;
                              return Promise.resolve(s).then(function (n) {
                                return Promise.resolve(_e5.call(_c4, t, n)).then(function () {});
                              });
                            }
                          }();
                          return n && n.then ? n.then(e) : e();
                        }));
                      };
                      var _n4;
                      var _o6 = function () {
                        if (!t.animation.animate) return Promise.resolve(_c4.hooks.call("animation:skip", void 0)).then(function () {
                          var e = _c4.renderPage;
                          return Promise.resolve(s).then(function (o) {
                            return Promise.resolve(e.call(_c4, t, o)).then(function () {
                              _n4 = 1;
                            });
                          });
                        });
                      }();
                      return Promise.resolve(_o6 && _o6.then ? _o6.then(_e3) : _e3(_o6));
                    } catch (r) {
                      return Promise.reject(r);
                    }
                  })).then(function () {
                    if (!t.done) return Promise.resolve(_c4.hooks.call("visit:end", t, void 0, function () {
                      return _c4.classes.clear();
                    })).then(function () {
                      t.state = 7, _c4.navigating = !1, _c4.onVisitEnd && (_c4.onVisitEnd(), _c4.onVisitEnd = void 0);
                    });
                  });
                }
                t.state = 3;
                var s = _c4.hooks.call("page:load", t, {
                  options: e
                }, function (t, e) {
                  try {
                    var _n5 = function _n5(t) {
                      return e.page = t, e.cache = !!_o7, e.page;
                    };
                    var _o7;
                    return t.cache.read && (_o7 = _c4.cache.get(t.to.url)), Promise.resolve(_o7 ? _n5(_o7) : Promise.resolve(_c4.fetchPage(t.to.url, e.options)).then(_n5));
                  } catch (r) {
                    return Promise.reject(r);
                  }
                });
                s.then(function (_ref11) {
                  var e = _ref11.html;
                  t.advance(5), t.to.html = e, t.to.document = new DOMParser().parseFromString(e, "text/html");
                });
                var l = t.to.url + t.to.hash;
                t.history.popstate || ("replace" === t.history.action || t.to.url === _c4.location.url ? i(l) : (_c4.currentHistoryIndex++, r(l, {
                  index: _c4.currentHistoryIndex
                }))), _c4.location = a.fromUrl(l), t.history.popstate && _c4.classes.add("is-popstate"), t.animation.name && _c4.classes.add("to-".concat(n(t.animation.name)));
                var h = function () {
                  if (t.animation.wait) return Promise.resolve(s).then(function () {});
                }();
                return h && h.then ? h.then(o) : o();
              });
            } catch (t) {
              return s(t);
            }
            return l && l.then ? l.then(void 0, s) : l;
          }(0, function (e) {
            e && !(e !== null && e !== void 0 && e.aborted) ? (t.state = 9, console.error(e), _c4.options.skipPopStateHandling = function () {
              return window.location.assign(t.to.url + t.to.hash), !0;
            }, window.history.back()) : t.state = 8;
          });
        } catch (t) {
          return s(!0, t);
        }
        return l && l.then ? l.then(s.bind(null, !1), s.bind(null, !0)) : s(!1, l);
      }(0, function (e, n) {
        if (delete t.to.document, e) throw n;
        return n;
      });
    };
    var _s5;
    var _c4 = this;
    var _l3 = function () {
      if (_c4.navigating) return function () {
        if (!(_c4.visit.state >= 6)) return Promise.resolve(_c4.hooks.call("visit:abort", _c4.visit, void 0)).then(function () {
          delete _c4.visit.to.document, _c4.visit.state = 8;
        });
        t.state = 2, _c4.onVisitEnd = function () {
          return _c4.performNavigation(t, e);
        }, _s5 = 1;
      }();
    }();
    return Promise.resolve(_l3 && _l3.then ? _l3.then(_o5) : _o5(_l3));
  } catch (h) {
    return Promise.reject(h);
  }
};
function T(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if ("string" != typeof t) throw new Error("swup.navigate() requires a URL parameter");
  if (this.shouldIgnoreVisit(t, {
    el: n.el,
    event: n.event
  })) return void window.location.assign(t);
  var _a$fromUrl3 = a.fromUrl(t),
    o = _a$fromUrl3.url,
    r = _a$fromUrl3.hash,
    i = this.createVisit(_objectSpread(_objectSpread({}, n), {}, {
      to: o,
      hash: r
    }));
  this.performNavigation(i, e);
}
var q = function q(t) {
    try {
      var _e6 = this;
      return Promise.resolve(_e6.hooks.call("animation:out:start", t, void 0, function () {
        _e6.classes.add("is-changing", "is-animating", "is-leaving");
      })).then(function () {
        return Promise.resolve(_e6.hooks.call("animation:out:await", t, {
          skip: !1
        }, function (t, _ref12) {
          var n = _ref12.skip;
          if (!n) return _e6.awaitAnimations({
            selector: t.animation.selector
          });
        })).then(function () {
          return Promise.resolve(_e6.hooks.call("animation:out:end", t, void 0)).then(function () {});
        });
      });
    } catch (t) {
      return Promise.reject(t);
    }
  },
  R = function R(t) {
    var _e$querySelector;
    var e = t.to.document;
    if (!e) return !1;
    var n = ((_e$querySelector = e.querySelector("title")) === null || _e$querySelector === void 0 ? void 0 : _e$querySelector.innerText) || "";
    document.title = n;
    var o = m('[data-swup-persist]:not([data-swup-persist=""])'),
      r = t.containers.map(function (t) {
        var n = document.querySelector(t),
          o = e.querySelector(t);
        return n && o ? (n.replaceWith(o.cloneNode(!0)), !0) : (n || console.warn("[swup] Container missing in current document: ".concat(t)), o || console.warn("[swup] Container missing in incoming document: ".concat(t)), !1);
      }).filter(Boolean);
    return o.forEach(function (t) {
      var e = t.getAttribute("data-swup-persist"),
        n = d("[data-swup-persist=\"".concat(e, "\"]"));
      n && n !== t && n.replaceWith(t);
    }), r.length === t.containers.length;
  },
  N = function N(t) {
    var _this7 = this;
    var e = {
        behavior: "auto"
      },
      _t$scroll = t.scroll,
      n = _t$scroll.target,
      o = _t$scroll.reset,
      r = n !== null && n !== void 0 ? n : t.to.hash;
    var i = !1;
    return r && (i = this.hooks.callSync("scroll:anchor", t, {
      hash: r,
      options: e
    }, function (t, _ref13) {
      var e = _ref13.hash,
        n = _ref13.options;
      var o = _this7.getAnchorElement(e);
      return o && o.scrollIntoView(n), !!o;
    })), o && !i && (i = this.hooks.callSync("scroll:top", t, {
      options: e
    }, function (t, _ref14) {
      var e = _ref14.options;
      return window.scrollTo(_objectSpread({
        top: 0,
        left: 0
      }, e)), !0;
    })), i;
  },
  D = function D(t) {
    try {
      var _e7 = this;
      if (t.done) return Promise.resolve();
      var _n6 = _e7.hooks.call("animation:in:await", t, {
        skip: !1
      }, function (t, _ref15) {
        var n = _ref15.skip;
        if (!n) return _e7.awaitAnimations({
          selector: t.animation.selector
        });
      });
      return Promise.resolve(f()).then(function () {
        return Promise.resolve(_e7.hooks.call("animation:in:start", t, void 0, function () {
          _e7.classes.remove("is-animating");
        })).then(function () {
          return Promise.resolve(_n6).then(function () {
            return Promise.resolve(_e7.hooks.call("animation:in:end", t, void 0)).then(function () {});
          });
        });
      });
    } catch (t) {
      return Promise.reject(t);
    }
  },
  M = function M(t, e) {
    try {
      var _r5 = this;
      if (t.done) return Promise.resolve();
      t.advance(6);
      var _s6 = e.url;
      return _r5.isSameResolvedUrl(o(), _s6) || (i(_s6), _r5.location = a.fromUrl(_s6), t.to.url = _r5.location.url, t.to.hash = _r5.location.hash), Promise.resolve(_r5.hooks.call("content:replace", t, {
        page: e
      }, function (t, _ref16) {
        _objectDestructuringEmpty(_ref16);
        if (_r5.classes.remove("is-leaving"), t.animation.animate && _r5.classes.add("is-rendering"), !_r5.replaceContent(t)) throw new Error("[swup] Container mismatch, aborting");
        t.animation.animate && (_r5.classes.add("is-changing", "is-animating", "is-rendering"), t.animation.name && _r5.classes.add("to-".concat(n(t.animation.name))));
      })).then(function () {
        return Promise.resolve(_r5.hooks.call("content:scroll", t, void 0, function () {
          return _r5.scrollToContent(t);
        })).then(function () {
          return Promise.resolve(_r5.hooks.call("page:view", t, {
            url: _r5.location.url,
            title: document.title
          })).then(function () {});
        });
      });
    } catch (t) {
      return Promise.reject(t);
    }
  },
  O = function O(t) {
    var _e8;
    var e;
    if (e = t, Boolean((_e8 = e) === null || _e8 === void 0 ? void 0 : _e8.isSwupPlugin)) {
      if (t.swup = this, !t._checkRequirements || t._checkRequirements()) return t._beforeMount && t._beforeMount(), t.mount(), this.plugins.push(t), this.plugins;
    } else console.error("Not a swup plugin instance", t);
  };
function W(t) {
  var e = this.findPlugin(t);
  if (e) return e.unmount(), e._afterUnmount && e._afterUnmount(), this.plugins = this.plugins.filter(function (t) {
    return t !== e;
  }), this.plugins;
  console.error("No such plugin", e);
}
function B(t) {
  return this.plugins.find(function (e) {
    return e === t || e.name === t || e.name === "Swup".concat(String(t));
  });
}
function _(t) {
  if ("function" != typeof this.options.resolveUrl) return console.warn("[swup] options.resolveUrl expects a callback function."), t;
  var e = this.options.resolveUrl(t);
  return e && "string" == typeof e ? e.startsWith("//") || e.startsWith("http") ? (console.warn("[swup] options.resolveUrl needs to return a relative url"), t) : e : (console.warn("[swup] options.resolveUrl needs to return a url"), t);
}
function F(t, e) {
  return this.resolveUrl(t) === this.resolveUrl(e);
}
var K = {
  animateHistoryBrowsing: !1,
  animationSelector: '[class*="transition-"]',
  animationScope: "html",
  cache: !0,
  containers: ["#swup"],
  ignoreVisit: function ignoreVisit(t) {
    var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      e = _ref17.el;
    return !!(e !== null && e !== void 0 && e.closest("[data-no-swup]"));
  },
  linkSelector: "a[href]",
  linkToSelf: "scroll",
  "native": !1,
  plugins: [],
  resolveUrl: function resolveUrl(t) {
    return t;
  },
  requestHeaders: {
    "X-Requested-With": "swup",
    Accept: "text/html, application/xhtml+xml"
  },
  skipPopStateHandling: function skipPopStateHandling(t) {
    var _t$state;
    return "swup" !== ((_t$state = t.state) === null || _t$state === void 0 ? void 0 : _t$state.source);
  },
  timeout: 0
};
var z = /*#__PURE__*/function () {
  function z() {
    var _window$history$state, _window$history$state2;
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, z);
    this.version = "4.7.0", this.options = void 0, this.defaults = K, this.plugins = [], this.visit = void 0, this.cache = void 0, this.hooks = void 0, this.classes = void 0, this.location = a.fromUrl(window.location.href), this.currentHistoryIndex = void 0, this.clickDelegate = void 0, this.navigating = !1, this.onVisitEnd = void 0, this.use = O, this.unuse = W, this.findPlugin = B, this.log = function () {}, this.navigate = T, this.performNavigation = L, this.createVisit = P, this.delegateEvent = s, this.fetchPage = l, this.awaitAnimations = x, this.renderPage = M, this.replaceContent = R, this.animatePageIn = D, this.animatePageOut = q, this.scrollToContent = N, this.getAnchorElement = $, this.getCurrentUrl = o, this.resolveUrl = _, this.isSameResolvedUrl = F, this.options = _objectSpread(_objectSpread({}, this.defaults), t), this.handleLinkClick = this.handleLinkClick.bind(this), this.handlePopState = this.handlePopState.bind(this), this.cache = new u(this), this.classes = new y(this), this.hooks = new U(this), this.visit = this.createVisit({
      to: ""
    }), this.currentHistoryIndex = (_window$history$state = (_window$history$state2 = window.history.state) === null || _window$history$state2 === void 0 ? void 0 : _window$history$state2.index) !== null && _window$history$state !== void 0 ? _window$history$state : 1, this.enable();
  }
  _createClass(z, [{
    key: "currentPageUrl",
    get: function get() {
      return this.location.url;
    }
  }, {
    key: "enable",
    value: function enable() {
      try {
        var _window$history$state3;
        var _t4 = this,
          _e9 = _t4.options.linkSelector;
        return _t4.clickDelegate = _t4.delegateEvent(_e9, "click", _t4.handleLinkClick), window.addEventListener("popstate", _t4.handlePopState), _t4.options.animateHistoryBrowsing && (window.history.scrollRestoration = "manual"), _t4.options["native"] = _t4.options["native"] && !!document.startViewTransition, _t4.options.plugins.forEach(function (e) {
          return _t4.use(e);
        }), "swup" !== ((_window$history$state3 = window.history.state) === null || _window$history$state3 === void 0 ? void 0 : _window$history$state3.source) && i(null, {
          index: _t4.currentHistoryIndex
        }), Promise.resolve(f()).then(function () {
          return Promise.resolve(_t4.hooks.call("enable", void 0, void 0, function () {
            var e = document.documentElement;
            e.classList.add("swup-enabled"), e.classList.toggle("swup-native", _t4.options["native"]);
          })).then(function () {});
        });
      } catch (t) {
        return Promise.reject(t);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      try {
        var _t5 = this;
        return _t5.clickDelegate.destroy(), window.removeEventListener("popstate", _t5.handlePopState), _t5.cache.clear(), _t5.options.plugins.forEach(function (e) {
          return _t5.unuse(e);
        }), Promise.resolve(_t5.hooks.call("disable", void 0, void 0, function () {
          var t = document.documentElement;
          t.classList.remove("swup-enabled"), t.classList.remove("swup-native");
        })).then(function () {
          _t5.hooks.clear();
        });
      } catch (t) {
        return Promise.reject(t);
      }
    }
  }, {
    key: "shouldIgnoreVisit",
    value: function shouldIgnoreVisit(t) {
      var _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        e = _ref18.el,
        n = _ref18.event;
      var _a$fromUrl4 = a.fromUrl(t),
        o = _a$fromUrl4.origin,
        r = _a$fromUrl4.url,
        i = _a$fromUrl4.hash;
      return o !== window.location.origin || !(!e || !this.triggerWillOpenNewWindow(e)) || !!this.options.ignoreVisit(r + i, {
        el: e,
        event: n
      });
    }
  }, {
    key: "handleLinkClick",
    value: function handleLinkClick(t) {
      var _this8 = this;
      var e = t.delegateTarget,
        _a$fromElement = a.fromElement(e),
        n = _a$fromElement.href,
        o = _a$fromElement.url,
        r = _a$fromElement.hash;
      if (this.shouldIgnoreVisit(n, {
        el: e,
        event: t
      })) return;
      if (this.navigating && o === this.visit.to.url) return void t.preventDefault();
      var s = this.createVisit({
        to: o,
        hash: r,
        el: e,
        event: t
      });
      t.metaKey || t.ctrlKey || t.shiftKey || t.altKey ? this.hooks.callSync("link:newtab", s, {
        href: n
      }) : 0 === t.button && this.hooks.callSync("link:click", s, {
        el: e,
        event: t
      }, function () {
        var _s$from$url;
        var e = (_s$from$url = s.from.url) !== null && _s$from$url !== void 0 ? _s$from$url : "";
        t.preventDefault(), o && o !== e ? _this8.isSameResolvedUrl(o, e) || _this8.performNavigation(s) : r ? _this8.hooks.callSync("link:anchor", s, {
          hash: r
        }, function () {
          i(o + r), _this8.scrollToContent(s);
        }) : _this8.hooks.callSync("link:self", s, void 0, function () {
          "navigate" === _this8.options.linkToSelf ? _this8.performNavigation(s) : (i(o), _this8.scrollToContent(s));
        });
      });
    }
  }, {
    key: "handlePopState",
    value: function handlePopState(t) {
      var _t$state$url,
        _t$state2,
        _t$state$index,
        _t$state3,
        _this9 = this;
      var e = (_t$state$url = (_t$state2 = t.state) === null || _t$state2 === void 0 ? void 0 : _t$state2.url) !== null && _t$state$url !== void 0 ? _t$state$url : window.location.href;
      if (this.options.skipPopStateHandling(t)) return;
      if (this.isSameResolvedUrl(o(), this.location.url)) return;
      var _a$fromUrl5 = a.fromUrl(e),
        n = _a$fromUrl5.url,
        r = _a$fromUrl5.hash,
        i = this.createVisit({
          to: n,
          hash: r,
          event: t
        });
      i.history.popstate = !0;
      var s = (_t$state$index = (_t$state3 = t.state) === null || _t$state3 === void 0 ? void 0 : _t$state3.index) !== null && _t$state$index !== void 0 ? _t$state$index : 0;
      s && s !== this.currentHistoryIndex && (i.history.direction = s - this.currentHistoryIndex > 0 ? "forwards" : "backwards", this.currentHistoryIndex = s), i.animation.animate = !1, i.scroll.reset = !1, i.scroll.target = !1, this.options.animateHistoryBrowsing && (i.animation.animate = !0, i.scroll.reset = !0), this.hooks.callSync("history:popstate", i, {
        event: t
      }, function () {
        _this9.performNavigation(i);
      });
    }
  }, {
    key: "triggerWillOpenNewWindow",
    value: function triggerWillOpenNewWindow(t) {
      return !!t.matches('[download], [target="_blank"]');
    }
  }]);
  return z;
}();
export { a as Location, n as classify, r as createHistoryRecord, z as default, s as delegateEvent, g as forceReflow, w as getContextualAttr, o as getCurrentUrl, p as isPromise, c as matchPath, f as nextTick, d as query, m as queryAll, v as runAsPromise, i as updateHistoryRecord };